import { GolfGreenSvg } from "../components/sports/GolfGreenSvg.tsx";
import { useI18n } from "../i18n/context.tsx";
import styles from "./ComingSoon.module.css";
import { ComingSoonTemplate } from "./ComingSoonTemplate.tsx";

export function GolfAiPage() {
  const { t } = useI18n();
  return (
    <ComingSoonTemplate
      sport={t.golf}
      variant="ai"
      badgeClass={styles.badgeGolf}
      svgPreview={<GolfGreenSvg />}
      seoTitle="ShootCreator Golf AI - Coming Soon"
      seoDesc="AI-powered golf short game analysis with green-side biometrics and voice transcription. Coming soon."
      canonicalPath="/golf/ai"
    />
  );
}
